
import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
 } from "reactstrap";
import {
  Link
} from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import "assets/css/custom.css";
import UserService from '../../services/api/User';
import { toast } from 'react-toastify';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import ReactTable from "react-table";
import { Scrollbars } from 'react-custom-scrollbars';
import Pagination from "../../assets/js/Pagination";


class UserManagement extends React.Component { 
  constructor(props) {
    super(props);
           
    this.state = {
      userdetails:[],
      columns:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight

      };
      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      this.state.columns = [
        {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      }, 
      {
      Header: 'Edit',
      accessor: 'Edit',
      maxWidth: 100
       },
        {
      Header: 'First Name',
      accessor: 'FirstName',
      sortable: true,
       }, 
      {
      Header: 'Last Name',
      accessor: 'LastName',
      maxWidth: 200
    }, {
      Header: 'Email',
      accessor: 'Email'
    }, {
      Header: 'Organisation',
      accessor: 'Organisation'
    },
    {
      Header: 'Role',
      accessor: 'Role'
    }
  ];
};


  
  componentDidMount() {
//    document.body.style.backgroundColor= '#fff !important';
   this.state.usersid=  localStorage.getItem("Uid");
   this.GetAllUsers(this.state.usersid);
   this.updateWindowDimensions();
   window.addEventListener('resize', this.updateWindowDimensions);

  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }
  GetAllUsers  = (allid) =>{
    this.setState( { loading:true} );
    UserService.getAllUsers(this.state.usersid)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let userDt = response.userDTOS;
        this.renderData(userDt);  
        this.setState( { loading:false} );
          } else {
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
    })
  }

  // Edit user mgt
  EditParticularuser(data){
    this.props.history.push({
      pathname: '/admin/newuser',
      state: { EditData: data,mode:"edit" }
    })
  }


  renderData(userData){
    let datas = [];
   
    userData.map((item, index) => {
      datas.push({
        Edit:<div><i style={{cursor:"pointer"}} onClick={e=>this.EditParticularuser(item)} className="fa fa-edit text-info"/></div>,
        Id: item.id, 
        FirstName: <div>{!item.status && <i style={{marginRight:7}} className="fa fa-lock text-grey"  />}{item.firstName}</div>,
        LastName:item.lastName,
        Email:item.email,
        Organisation:item.organisation,
        Role:item.role,
       })
     });
     this.setState({
       userdetails:datas
     });

}

  render() {
   
    return (
   
      <>
      <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
          <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
          <Row>
            <Col xs={12} md={12}>
           <Row>
            <div className=" col">
              <Card>
                <CardHeader>
                   <Row className="align-items-center">
                    <div className="col">
                      <h5 className="mb-0">User Management</h5>
                  
                    </div>
                    <div className="col text-right">
                      <Link to="usermanagement" > 
                       <span> <i className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllUsers(this.state.usersid)}/></span>
                      </Link>
                       <Link to={{
                        pathname: 'newuser',
                        state: { mode: "addnew" }
                      }}>
                         <Button
                        color="primary"
                        href="#pablo"
                        size="sm"
                      >
                      New User
                      </Button>
                      </Link>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>

                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-200}>

        <ReactTable
         data={ this.state.userdetails }
         columns={ this.state.columns }
         defaultPageSize={10}
         showPaginationBottom={true}
         PaginationComponent={Pagination}
         className="-striped -highlight Usertable"
          />
           </Scrollbars>

       </div>
                </CardBody>
              </Card>
            </div>
          </Row>
          
          </Col>
          </Row>
          </LoadingOverlay>

          </div>
      </>
    );
  }
}

export default UserManagement;